<template>
    <el-drawer title="权益" :visible.sync="drawerShow" :destroy-on-close="true" :size="500"
        @close="close">
        <div class="drawer-content">
            <template v-if="rights">
                <el-card v-for="(item,index) in rights" :key="index" class="MT10">
                    <div slot="header" class="card-header">
                        <div class="name">{{item.rightsName}}</div>
                        <div class="status">{{item.statusDesc}}</div>
                    </div>
                    <div>
                        <label class="color-info">权益描述：</label>
                        {{item.rightsDesc}}
                    </div>
                    <div class="MT15">
                        <label class="color-info">权益有效期：</label>
                        {{item.validStartTime ? `${item.validStartTime} 至 ` : ""}} {{item.validEndTime || '兑换前长期有效'}}
                    </div>
                </el-card>
            </template>
            <div v-else class="center">
                <el-empty description="暂无相关权益" :image-size="100"></el-empty>
            </div>
        </div>
        <!-- <div class="drawer-footer">
            <el-button @click="close">取消</el-button>
        </div> -->
    </el-drawer>
</template>
<script>

export default {
    data() {
        return {
            drawerShow: false,
            rights: []
        }
    },
    methods: {
        close() {
            this.rights = []
            this.drawerShow = false;

        },
        show(data) {
            this.rights = data;
            this.drawerShow = true;
        }
    }
}
</script>

<style lang="scss" scoped>
.card-header{
    display: flex;
    align-items: center;
    justify-content: space-between;
    .name{
        font-size: 14px;
    }
}
.center{
    .el-empty{
        display: flex;
        flex-direction: column;
        align-items: center;
    }
}
</style>